/* Extra swipe slides stay in <template> on collection/search so desktop and first paint skip those images. */
(function () {
  if (window.__semodeSwipeHydrate) return;
  window.__semodeSwipeHydrate = true;

  var QUERY = 'template.product-item__swipe-more';
  var mq = window.matchMedia('(max-width: 999px)');

  function hydrate(root) {
    if (!mq.matches) return;
    (root || document).querySelectorAll(QUERY).forEach(function (tpl) {
      if (!tpl.content) return;
      tpl.replaceWith(tpl.content.cloneNode(true));
    });
  }

  function start() {
    hydrate(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  if (mq.addEventListener) mq.addEventListener('change', start);
  else mq.addListener(start);

  document.addEventListener('shopify:section:load', function (event) {
    hydrate(event.target);
  });

  document.addEventListener('loadmore:page-loaded', function () {
    hydrate(document);
  });
})();

/* Filter sheet: App draft — chips stay local until Apply. Reset clears the draft. */
(function () {
  if (window.__semodeFilterSheet) return;
  window.__semodeFilterSheet = true;

  function sheetOf(node) {
    return node && node.closest && node.closest('#facet-filters.facet-filters--app');
  }

  function formOf(sheet) {
    return sheet && sheet.querySelector('#facet-filters-form');
  }

  function selectedCount(sheet) {
    var n = 0;
    sheet.querySelectorAll('#facet-filters-form [name^="filter."]').forEach(function (el) {
      if (el.type === 'checkbox' || el.type === 'radio') {
        if (el.checked) n += 1;
      } else if (el.value) {
        n += 1;
      }
    });
    return n;
  }

  function syncReset(sheet) {
    var reset = sheet.querySelector('.facet-filters__reset');
    if (!reset) return;
    var empty = selectedCount(sheet) === 0;
    reset.classList.toggle('is-empty', empty);
    if (empty) reset.setAttribute('hidden', 'hidden');
    else reset.removeAttribute('hidden');
  }

  function clearDraft(sheet) {
    sheet.querySelectorAll('#facet-filters-form [name^="filter."]').forEach(function (el) {
      if (el.type === 'checkbox' || el.type === 'radio') el.checked = false;
      else el.value = '';
    });
    sheet.querySelectorAll('price-range input.range').forEach(function (el, i) {
      el.value = i % 2 === 0 ? el.min : el.max;
    });
    syncReset(sheet);
  }

  function formUrl(sheet) {
    var form = formOf(sheet);
    if (!form) return window.location.pathname;
    var params = new URLSearchParams(new FormData(form));
    Array.from(params.keys()).forEach(function (key) {
      if (key.indexOf('filter.') === 0 && !params.get(key)) params.delete(key);
    });
    var q = params.toString();
    return q ? window.location.pathname + '?' + q : window.location.pathname;
  }

  function fireCriteria(sheet, url) {
    sheet.dispatchEvent(new CustomEvent('facet:criteria-changed', { bubbles: true, detail: { url: url } }));
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    var sheet = sheetOf(input);
    if (!sheet || !input.name || input.name.indexOf('filter.') !== 0) return;
    event.stopPropagation();
    event.stopImmediatePropagation();
    syncReset(sheet);
  }, true);

  document.addEventListener('click', function (event) {
    var reset = event.target.closest && event.target.closest('#facet-filters.facet-filters--app .facet-filters__reset');
    if (!reset) return;
    var sheet = sheetOf(reset);
    if (!sheet) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    clearDraft(sheet);
  }, true);

  document.addEventListener('click', function (event) {
    var apply = event.target.closest && event.target.closest('#facet-filters.facet-filters--app .facet-filters__apply');
    if (!apply) return;
    var sheet = sheetOf(apply);
    if (!sheet) return;
    event.preventDefault();
    event.stopPropagation();
    fireCriteria(sheet, formUrl(sheet));
    if ('open' in sheet) sheet.open = false;
    else sheet.removeAttribute('open');
  }, true);

  document.addEventListener('shopify:section:load', function (event) {
    var sheet = event.target && event.target.querySelector && event.target.querySelector('#facet-filters.facet-filters--app');
    if (sheet) syncReset(sheet);
  });
})();
